// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml = require("rescript/lib/js/caml.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Core__Math = require("@rescript/core/src/Core__Math.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_SetInt = require("rescript/lib/js/belt_SetInt.js");
var Belt_SetString = require("rescript/lib/js/belt_SetString.js");
var Core__Ordering = require("@rescript/core/src/Core__Ordering.res.js");
var Caml_exceptions = require("rescript/lib/js/caml_exceptions.js");

var exn = Js_exn.raiseError;

var clearArray = (arr => arr.length = 0);

function arrFlatMap(arr, func) {
  return Belt_Array.concatMany(Belt_Array.map(arr, func));
}

function arrStrDistinct(arr) {
  return Belt_SetString.toArray(Belt_SetString.fromArray(arr));
}

function arrIntDistinct(arr) {
  return Belt_SetInt.toArray(Belt_SetInt.fromArray(arr));
}

function arrForEach(arr, consumer) {
  var len = arr.length;
  var i = 0;
  var res;
  while(i < len && Belt_Option.isNone(res)) {
    res = consumer(arr[i]);
    i = i + 1 | 0;
  };
  return res;
}

function arrJoin(arr, sep) {
  var arrLen = arr.length;
  if (arrLen < 2) {
    return arr;
  }
  var res = new Array((arrLen << 1) - 1 | 0);
  var maxI = arrLen - 1 | 0;
  for(var i = 0; i <= maxI; ++i){
    res[(i << 1)] = arr[i];
    if (i !== maxI) {
      res[(i << 1) + 1 | 0] = sep;
    }
    
  }
  return res;
}

function copySubArray(src, srcFromIdx, dst, dstFromIdx, len) {
  var s = srcFromIdx;
  var d = dstFromIdx;
  var srcLen = src.length;
  var dstLen = dst.length;
  var sMax = Math.min(srcLen - 1 | 0, (srcFromIdx + len | 0) - 1 | 0);
  while(s <= sMax && d < dstLen) {
    dst[d] = src[s];
    d = d + 1 | 0;
    s = s + 1 | 0;
  };
}

function toIntCmp(cmp) {
  return function (a, b) {
    return Core__Math.Int.floor(Math.sign(cmp(a, b)));
  };
}

function strCmpI(s1, s2) {
  return Caml.string_compare(s1.toLocaleUpperCase(), s2.toLocaleUpperCase());
}

function cmpRev(cmp) {
  return function (a, b) {
    return Core__Ordering.invert(cmp(a, b));
  };
}

function stringify(a) {
  var str = JSON.stringify(a);
  if (str !== undefined) {
    return str;
  } else {
    return "undefined";
  }
}

var ExplnUtilsException = /* @__PURE__ */Caml_exceptions.create("Expln_utils_common.ExplnUtilsException");

function comparatorByInt(prop) {
  return function (a, b) {
    return Caml.int_compare(prop(a), prop(b));
  };
}

function comparatorByStr(prop) {
  return function (a, b) {
    return Caml.string_compare(prop(a), prop(b));
  };
}

function comparatorAndThen(cmp1, cmp2) {
  return function (x, y) {
    var res1 = cmp1(x, y);
    if (Core__Ordering.isEqual(res1)) {
      return cmp2(x, y);
    } else {
      return res1;
    }
  };
}

var hashStr = (str => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = ( ( hash << 5 ) - hash ) + str.charCodeAt(i);
            hash |= 0;  // Convert to 32-bit integer
        }
        return hash;
    });

var hashArrInt = (arr => {
        let hash = 0;
        for (let i = 0; i < arr.length; i++) {
            hash = ( ( hash << 5 ) - hash ) + arr[i];
            hash |= 0;  // Convert to 32-bit integer
        }
        return hash;
    });

var hashArrIntFromTo = ((arr,from,to) => {
        let hash = 0;
        for (let i = from; i <= to; i++) {
            hash = ( ( hash << 5 ) - hash ) + arr[i];
            hash |= 0;  // Convert to 32-bit integer
        }
        return hash;
    });

var hash2 = ((a,b) => ( ( ( a << 5 ) - a ) + b ) | 0);

function sortInPlaceWith(arr, cmp) {
  arr.sort(cmp);
  return arr;
}

exports.exn = exn;
exports.clearArray = clearArray;
exports.arrFlatMap = arrFlatMap;
exports.arrStrDistinct = arrStrDistinct;
exports.arrIntDistinct = arrIntDistinct;
exports.arrForEach = arrForEach;
exports.arrJoin = arrJoin;
exports.copySubArray = copySubArray;
exports.toIntCmp = toIntCmp;
exports.strCmpI = strCmpI;
exports.cmpRev = cmpRev;
exports.stringify = stringify;
exports.ExplnUtilsException = ExplnUtilsException;
exports.comparatorByInt = comparatorByInt;
exports.comparatorByStr = comparatorByStr;
exports.comparatorAndThen = comparatorAndThen;
exports.hashStr = hashStr;
exports.hashArrInt = hashArrInt;
exports.hashArrIntFromTo = hashArrIntFromTo;
exports.hash2 = hash2;
exports.sortInPlaceWith = sortInPlaceWith;
/* No side effect */
